import styled from 'styled-components'
import { palette } from '../../Styles/colors'

const Container = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  align-self: flex-end;
  background-color: ${palette.highlight};
  border-radius: 50%;
  padding: 0.2em;
  width: calc(100% * (1/3) - 0.2em - 1px);
`

export { Container }



// WEBPACK FOOTER //
// ./src/Components/Seen/styles.js